import { useId } from "react";
import { motion } from "framer-motion";
import { VIEWBOX, PATH_A, PATH_B } from "@/lib/indiaPath";

export const IndiaMap = ({ className = "", stroke = "#DD7A3A", opacity = 1, children }) => {
  const uid = useId().replace(/:/g, "");
  const gold = `gold-${uid}`;
  const halo = `halo-${uid}`;
  const glow = `glow-${uid}`;
  return (
    <div className={`relative select-none ${className}`} style={{ containerType: "size" }} data-testid="india-map">
      <motion.svg
        viewBox={VIEWBOX}
        className="w-full h-full pointer-events-none"
        fill="none"
        style={{ opacity }}
        aria-hidden="true"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <defs>
          <linearGradient id={gold} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#F3B94A" stopOpacity="0" />
            <stop offset="0.42" stopColor="#F7CD6B" stopOpacity="0.9" />
            <stop offset="0.5" stopColor="#FFF1C2" stopOpacity="1" />
            <stop offset="0.58" stopColor="#F7CD6B" stopOpacity="0.9" />
            <stop offset="1" stopColor="#F3B94A" stopOpacity="0" />
            <animate attributeName="y1" values="-0.55;1.15" dur="5.5s" repeatCount="indefinite" />
            <animate attributeName="y2" values="-0.15;1.55" dur="5.5s" repeatCount="indefinite" />
          </linearGradient>
          <linearGradient id={halo} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#F3B94A" stopOpacity="0" />
            <stop offset="0.5" stopColor="#F7CD6B" stopOpacity="0.55" />
            <stop offset="1" stopColor="#F3B94A" stopOpacity="0" />
            <animate attributeName="y1" values="-0.75;0.95" dur="5.5s" repeatCount="indefinite" />
            <animate attributeName="y2" values="0.05;1.75" dur="5.5s" repeatCount="indefinite" />
          </linearGradient>
          <filter id={glow} x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="3" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        {[PATH_A, PATH_B].map((d, i) => (
          <g key={i}>
            <path d={d} stroke={stroke} strokeWidth="7" strokeOpacity="0.1" strokeLinecap="round" strokeLinejoin="round" />
            <path d={d} stroke={stroke} strokeWidth="2.4" strokeOpacity="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path d={d} stroke={`url(#${halo})`} strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" filter={`url(#${glow})`} />
            <path d={d} stroke={`url(#${gold})`} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" filter={`url(#${glow})`} />
          </g>
        ))}
      </motion.svg>
      {children}
    </div>
  );
};
